import Control from "../../../assets/vfx/controls/control";
import { GridRoleDto, SearchRoleDto } from "../../../services/dto";
import { IControlStyles, PageContent, useControlStyles, } from "../../../assets/layouts";
import React from "react";
import Form from "../../../assets/vfx/form/form";
import { Col } from "react-bootstrap";
import { SearchContainer } from "../../../assets/vfx/search/searchContainer";
import { RoleService } from "./roleService";
import { Constants } from "../../../assets/utils/lib/constants";
import { GRID_ACTION_TYPES } from "../../../assets/types";
import { ControlDataGridColumnProps } from "../../../assets/vfx/controls/components/datagrid/controlDataGrid";
import { createActionColumn, createLayoutOptions, } from "../../../assets/configuration/gridConfig";

interface RolePageProps {
  controlStyles?: IControlStyles | undefined;
  onCustomEvent?: (actionType: string, dataId: string) => void;
}

const defaultSearchQuery: SearchRoleDto = {
  name: Constants.emptyString,
  pageNumber: 1,
  pageSize: 10,
};

const DATA_ID_FIELD = "id";

const gridColumns: ControlDataGridColumnProps[] = [
  {
    data: DATA_ID_FIELD,
    title: "ID",
    visible: false,
    columnType: "number",
    alignment: "right",
    sortable: false,
  },
  {
    data: "display",
    title: "Display",
    visible: true,
    columnType: "text",
    alignment: "left",
    width: "34%",
  },
];

export const RolePage = (props: RolePageProps) => {
  const [searchQuery, setSearchQuery] =
    React.useState<SearchRoleDto>(defaultSearchQuery);

  const styles: IControlStyles = props.controlStyles ?? useControlStyles();

  const roleGridQuery = RoleService.gridQuery(searchQuery);
  const { data } = roleGridQuery;
  const isGridLoading = roleGridQuery.isLoading || roleGridQuery.isFetching;
  const roles: GridRoleDto[] = data?.result ?? [];
  const hasData: boolean = roles.length > 0;
  const actionColumn = createActionColumn(styles, DATA_ID_FIELD, [
    GRID_ACTION_TYPES.EDIT,
    GRID_ACTION_TYPES.VIEW,
    GRID_ACTION_TYPES.PERMISSION,
  ]);
  const layoutOptions = createLayoutOptions(hasData);

  const handleSearch = (values: any): void => {
    const updatedSearchQuery: SearchRoleDto = { ...defaultSearchQuery };
        if (values.name) updatedSearchQuery.name = values.name;        
        setSearchQuery(updatedSearchQuery);    
  };

  const handleClear = (): void => {
    setSearchQuery(prev => ({
          ...defaultSearchQuery,
          sortBy: prev.sortBy,
          pageSize: prev.pageSize ?? 10,
      }));
  };

  const handleNew = (): void | undefined => {
    props.onCustomEvent?.(GRID_ACTION_TYPES.NEW, Constants.emptyGuid);
  };

  return (
    <PageContent title="Roles">
      <SearchContainer
        initialValues={searchQuery}
        onSearch={handleSearch}
        onNew={handleNew}
        onClear={handleClear}
        enableReinitialize
      >
        <Col lg={4}>
          <Form.Text name={"name"} label={"Name"} />
        </Col>
      </SearchContainer>

      <Control.DataGrid
        dataId={DATA_ID_FIELD}
        cols={gridColumns}
        actionCol={actionColumn}
        layoutOptions={layoutOptions}
        onCustomEvent={props.onCustomEvent}
        data={roles}
        totalRecords={data?.totalSize ?? (data?.result?.length ?? 0)}
        query={searchQuery}
        loading={isGridLoading}
        onQueryChange={(patch) => setSearchQuery(query => ({ ...query, ...patch }))}
      />
    </PageContent>
  );
};
